import ConsumptionBadges from "./ConsumptionBadges";
import NewChatButton from "./NewChatButton";
import ActiveBrandPill from "./ActiveBrandPill";

/**
 * Sticky top bar that sits above each page's content.
 * Holds the global consumption badges (imgs/day, COP today/month)
 * so every authenticated screen surfaces the same info.
 *
 * Left block always exposes:
 *   [ + Nuevo chat ]  [ Marca: <NombreMarca> ]
 * so the two most critical affordances are one click away from anywhere.
 *
 * Usage inside <main>:
 *   <PageTopBar />
 *   <div>…page content…</div>
 */
export default function PageTopBar({ breadcrumb, right }) {
    return (
        <header
            data-testid="page-top-bar"
            className="sticky top-0 z-30 h-16 shrink-0 flex items-center gap-4 px-6 lg:px-10 border-b hairline border-ink-600 bg-ink-950/80 backdrop-blur-md"
        >
            <div className="flex items-center gap-3 min-w-0 shrink-0">
                <NewChatButton />
                <ActiveBrandPill />
            </div>
            {breadcrumb && (
                <div className="flex items-center gap-2 min-w-0 flex-1 pl-2">
                    {breadcrumb}
                </div>
            )}
            <div className={breadcrumb ? "" : "flex-1"} />
            <ConsumptionBadges />
            {right}
        </header>
    );
}
